import selectCurrentOrder
    from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import {
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_GENERAL_ADMISSION,
    SEAT_PURCHASE_STATUS_FREE,
    GENERAL_ADMISSION_PURCHASE_STATUS_FREE,
    GENERAL_ADMISSION_PURCHASE_STATUS_RESERVED,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import { selectSeatByHash } from '%paysera_seat_selection/js/seatSelection/redux';
import setSeatsPurchaseStatus from './setSeatsPurchaseStatus';
import setGeneralAdmissionsPurchaseStatus from './setGeneralAdmissionsPurchaseStatus';
import setGeneralAdmissionsUsedSeatsCount from './setGeneralAdmissionsUsedSeatsCount';
import selectGeneralAdmissionByHash from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/selectors/selectGeneralAdmissionByHash';
import { setDiscardedTicketTypeForSeats } from '%paysera_seat_selection_integration/js/seatings/redux';

function seatingDiscarded(seating) {
    return (dispatch, getState) => {
        const order = selectCurrentOrder(getState());
        if (!order) {
            return;
        }
        const { type, hash, seats_used: usedSeatsCount, ticket_type_hash: ticketTypeHash } = seating;
        if (ticketTypeHash) {
            dispatch(setDiscardedTicketTypeForSeats({
                ticketTypeHash,
                usedSeatsCount,
            }));
        }

        if (type === OBJECT_TYPE_SEAT) {
            const seat = selectSeatByHash(getState(), hash);
            if (!seat) {
                return;
            }
            dispatch(setSeatsPurchaseStatus({
                seats: [seating],
                status: SEAT_PURCHASE_STATUS_FREE,
            }));
        }
        if (type === OBJECT_TYPE_GENERAL_ADMISSION) {
            dispatch(setGeneralAdmissionsUsedSeatsCount({
                [hash]: usedSeatsCount,
            }));

            const loadedGeneralAdmission = selectGeneralAdmissionByHash(getState(), hash);
            if (!loadedGeneralAdmission) {
                return;
            }

            const { purchaseStatus } = loadedGeneralAdmission;
            if (purchaseStatus === GENERAL_ADMISSION_PURCHASE_STATUS_RESERVED) {
                return;
            }

            dispatch(setGeneralAdmissionsPurchaseStatus({
                generalAdmissions: [seating],
                status: GENERAL_ADMISSION_PURCHASE_STATUS_FREE,
            }));
        }
    };
}

export default seatingDiscarded;
